module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/quote/modals/modal-send-quote/modal-send-quote.scss
// module id = ./web/modern/components/quote/modals/modal-send-quote/modal-send-quote.scss
// module chunks = 0